import { useCallback, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { API } from 'utils/api';
import { LOGIN } from 'store/actions';
import { UserContext } from 'contexts/UserContext';
import { showError, showSuccess } from 'utils/common';

const useImpersonation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loadUser } = useContext(UserContext);
  const user = useSelector((state) => state.account.user);

  const stopImpersonate = useCallback(async () => {
    try {
      const res = await API.post('/api/user/stop-impersonate');
      const { success, message, data } = res.data;
      if (success) {
        localStorage.setItem('user', JSON.stringify(data));
        dispatch({ type: LOGIN, payload: data });
        loadUser();
        showSuccess('已退出模拟登录');
        navigate('/panel/user');
        return true;
      }
      showError(message);
      return false;
    } catch (err) {
      showError('退出模拟登录失败');
      return false;
    }
  }, [dispatch, loadUser, navigate]);

  return {
    impersonating: !!user?.impersonating,
    impersonatorUsername: user?.impersonator_username || '',
    username: user?.username || '',
    stopImpersonate
  };
};

export default useImpersonation;
